// Reconnect backoff + jitter. SPEC client-transport §4.4.
//
// delay = min(maxMs, baseMs * factor^attempt), затем «дребезг» по jitter: delay*(1 - jitter*rand).
// jitter избегает thundering herd при общем обрыве у 20–100 клиентов. Сброс attempt — только после
// успешного `ready` (не после TCP), чтобы flapping не обнулял backoff (энфорсит RealtimeClient).
/**
 * Считает задержку перед попыткой `attempt` (0-based). `rand` инъецируется (дефолт Math.random) —
 * тесты делают jitter детерминированным. Возвращает целое число мс ≥ 0.
 */
export function backoffDelay(cfg, attempt, rand = Math.random) {
    const exp = cfg.baseMs * Math.pow(cfg.factor, Math.max(0, attempt));
    const capped = Math.min(cfg.maxMs, exp);
    // partial jitter: вычитаем до jitter-доли длительности (delay*(1 - jitter*rand)).
    const jittered = capped * (1 - cfg.jitter * clamp01(rand()));
    return Math.max(0, Math.round(jittered));
}
function clamp01(x) {
    if (!Number.isFinite(x))
        return 0;
    if (x < 0)
        return 0;
    if (x > 1)
        return 1;
    return x;
}
//# sourceMappingURL=backoff.js.map